/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import AbstractElement from "./abstract_element";
import IScene from "../scene_interface";
import Factory from "./factory";
import {RenderDocument} from "js_renderer";
import IElement from "./element_interface";
/**
 * @param {cadwork.webgl.SceneAPI.Scene} aSceneAPI
 * @extends cadwork.webgl.SceneAPI.elements.AbstractElement
 * @constructor
 */
export default
class Element extends AbstractElement implements IElement {

    public static TypeName: string = "Element";
    protected _properties: any;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this._properties = {};
    }

    // dummy element without knowledge of the type
    public static create(aSceneAPI: IScene): Element {
        let element: any = new Element(aSceneAPI);
        element._typeName = Element.TypeName;
        return element;
    }

    public setProperties(aProperties: any) {
        this._properties = {};
        this.extendProperties(aProperties);
    }

    public getProperties(): any {
        return this._properties;
    }

    public extendProperties(aProperties: any) {
        for (let property in aProperties) {
            if (aProperties.hasOwnProperty(property)) {
                this._properties[property] = aProperties[property];
            }
        }
    }

    public draw(aAddToRenderer: boolean): boolean {
        if (this._renderDocumentProperties.renderElement) {
            // add the element to render document only once
            return false;
        }

        let renderModel = this._renderDocumentProperties.renderModel;

        // add the model element to the model
        let element = renderModel.addElement(
            this._renderDocumentProperties.groupID,
            this.getTypeName(),
            this._generateElementDescriptionJSON(),
            this._generateGeometryObjectDescriptionJSON(),
            aAddToRenderer === undefined ? true : aAddToRenderer
        );

        element.setSceneAPIElementReference(this);

        this._renderDocumentProperties.renderElement = element;

        return true;
    }

    public focus(aFocusFactor: number, aAnimationTime: number) {
    }

    protected _generateElementDescriptionJSON() {
    }

    protected _generateGeometryObjectDescriptionJSON() {
    }
}

Factory.register(Element);
